

























































import { Vue, Component } from 'vue-property-decorator'
import reportService, { FlexBalance } from '@/services/reportService'
import utility from '@/common/utility'
import { Sort } from '@/services/data'
import SearchFilter from '@/components/search-filter.vue'
import SortHeader from '@/components/SortHeader.vue'

let pageTrades: FlexBalance[] = []

@Component({
  components: {
    SortHeader,
    SearchFilter
  }
})
export default class Trades extends Vue {
  dividends: FlexBalance[] = []
  selectedSymbols = new Array<string>()
  symbols: string[] = []
  isLoading = false

  async mounted () {
    await this.loadData(false)
  }

  async loadYear () {
    await reportService.getLastYearBalances()
    await this.$alert(this.$t('SYNC_DATA') as string)
  }

  async loadData (forceUpdate: boolean, updateLastYear?: boolean) {
    const data = await reportService.getBalances(forceUpdate, updateLastYear)
    if (data.Error) {
      await this.$alert(data.Error)
      return
    }
    pageTrades = data.Result
    this.symbols = utility.getDistinct(data.Result.map(p => utility.getSymbolDisplay(p.SymbolName, p.Currency)))
    this.dividends = utility.freezeArrayItems(pageTrades)
  }

  sortSymbol (direction: 'Asc' | 'Desc') {
    utility.sortByFiled(this.dividends, direction, p => p.SymbolName)
  }

  private filterSymbols () {
    const filter = pageTrades.filter(p => this.selectedSymbols.length === 0 || this.selectedSymbols.find(q => utility.iSameSymbol(q, p.SymbolName, p.Currency)))
    this.dividends = utility.freezeArrayItems(filter)
  }
}
